import React, {useContext, useRef} from "react";

import UIPopupContext from "../../PageLayout/Popups/UIPopupContext";
import {documentOptions} from "./achConstants";
import ACHContractSignatureField from "./ACHContractSignatureField";


const ACHContractDocument = () => {

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);

  const contractRef = useRef(null);
  const pageRef = useRef(null);

  if (!uiPopupContext.blobUrl) {
    return null;
  }

  const Document = window.ReactPdfDocument;
  const Page = window.ReactPdfPage;

  const onRender = (onRenObj) => {
    console.log("onRender", onRenObj);
    uiPopupDispatch({showPage: true});
    const receiptLayout = onRenObj ? onRenObj._INTERNAL__LAYOUT__DATA_ : null;
    const receiptPages = receiptLayout && receiptLayout.children ? receiptLayout.children.length : 1;
    uiPopupDispatch({receiptPages, receiptLayout});
  };

  return (
    <div className={"border-box m-auto p-2 relative w-auto" + (uiPopupContext.pageRendered ? " contract--ready" : "")}
         ref={contractRef}>
      <Document file={uiPopupContext.blobUrl}
                onLoadSuccess={onRender}
                options={documentOptions}>
        {uiPopupContext.showPage ? <Page ref={pageRef}
                                         pageNumber={1}
                                         onRenderSuccess={() => uiPopupDispatch({pageRendered: true})}
                                         scale={1.5}/> : null}
        {uiPopupContext.pageRendered ? <ACHContractSignatureField/> : null}
      </Document>
    </div>
  )
};

export default ACHContractDocument
